/**
 * The design has no floating cookie button: the settings open from the footer menu item „Cookies“
 * (`?occ=true` or the `eliadmin:open-cookie-preferences` event, see `cookie-consent-client.tsx`).
 * Kept as an empty component because the core app provider renders it.
 */
export function CookieConsentFab() {
  return null;
}
